module.exports = __webpack_public_path__ + "img/gold2.6eb2fb0f.png";